// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6a142215","703":"e923b555","787":"11ab8431"}[chunkId] + ".chunk.js";
};